import React from 'react';
import { Card, CardContent, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  card: {
    marginBottom: theme.spacing(3),
    borderRadius: theme.spacing(2),
    boxShadow: '0 2px 12px rgba(0,0,0,0.05)',
  },
  statsGrid: {
    marginTop: theme.spacing(2),
  },
  statCard: {
    padding: theme.spacing(2),
    textAlign: 'center',
    backgroundColor: '#f9fafb',
    borderRadius: theme.spacing(1),
    border: '1px solid #e5e7eb',
  },
  statNumber: {
    fontSize: '2rem',
    fontWeight: 700,
    color: '#374151',
  },
  statLabel: {
    fontSize: '0.875rem',
    color: '#6b7280',
    fontWeight: 500,
  },
}));

interface Stat {
  label: string;
  count: number;
  color: string;
}

interface StatsCardProps {
  stats: Stat[];
}

export const StatsCard: React.FC<StatsCardProps> = ({ stats }) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent>
        <Grid container spacing={2} className={classes.statsGrid}>
          {stats.map((stat, index) => (
            <Grid item xs={3} key={index}>
              <div className={classes.statCard}>
                <Typography className={classes.statNumber} style={{ color: stat.color }}>
                  {stat.count}
                </Typography>
                <Typography className={classes.statLabel}>{stat.label}</Typography>
              </div>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};
